import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestTransportDto = ClientInferResponseBody<
  typeof contract.quoteRequests.getTransport
>;

export const fetchQuoteRequestTransport = async (
  id: string,
): Promise<QuoteRequestTransportDto | null> => {
  const response = await api.quoteRequests.getTransport.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
